// Import Hook modules
import groupActivityTrackerApplyToAll from './apply_to_all';
import groupActivityTrackerSelectAll from './select_all';
import groupActivityTrackerSelectContact from './toggle_selected_contact';

export default {
  ...groupActivityTrackerApplyToAll,
  ...groupActivityTrackerSelectAll,
  ...groupActivityTrackerSelectContact,
};
